/* Keep photo navigation in sync with native collection filters and section reloads. */
if (!customElements.get('collection-category-navigation')) {
  customElements.define('collection-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.currentUrl = window.location.href;
      this.revealCurrent();
      const results = document.querySelector('[data-section-type="collection"] [data-partial]');
      if (!results) return;
      this.resultsObserver = new MutationObserver(() => {
        if (this.currentUrl !== window.location.href) this.refresh();
      });
      this.resultsObserver.observe(results, { childList: true });
    }

    revealCurrent() {
      this.resizeObserver?.disconnect();
      const track = this.querySelector('.scroll-slider__slider');
      const current = track?.querySelector('[data-active="true"]');
      if (!current) return;
      this.resizeObserver = new ResizeObserver(() => {
        const left = current.offsetLeft;
        if (!track.clientWidth || (left >= track.scrollLeft && left + current.offsetWidth <= track.scrollLeft + track.clientWidth)) return;
        track.scrollTo({ left: Math.max(0, left - (track.clientWidth - current.offsetWidth) / 2), behavior: 'instant' });
      });
      this.resizeObserver.observe(track);
    }

    async refresh() {
      this.currentUrl = window.location.href;
      this.request?.abort();
      const request = this.request = new AbortController();
      const url = new URL(this.currentUrl);
      url.searchParams.set('section_id', this.dataset.sectionId);
      url.searchParams.delete('page');
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('Navigation unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const navigation = doc.querySelector('.collection-categories');
        if (request.signal.aborted || !this.isConnected) return;
        if (!navigation) {
          this.hidden = true;
          return;
        }
        this.querySelector('.collection-categories').replaceWith(navigation);
        this.hidden = false;
        this.revealCurrent();
      } catch (error) {
        // Standard filters remain usable if the optional navigation cannot refresh.
        if (!request.signal.aborted) this.hidden = true;
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resultsObserver?.disconnect();
      this.request?.abort();
    }
  });
}
